import React, { useState } from "react"
import { ArrowRight, Clock } from "lucide-react"
import { useLang } from "./i18n/LangContext"

export function HeroSection() {
  const { t } = useLang()
  const [email, setEmail] = useState("")
  const [submitted, setSubmitted] = useState(false)
  const [focused, setFocused] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!email) return
    // TODO: wire to Rails waitlist endpoint
    setSubmitted(true)
  }

  return (
    <section className="relative overflow-hidden bg-white dark:bg-gray-950 py-24 sm:py-36">
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_60%_at_50%_-10%,rgba(99,102,241,0.15),transparent)] dark:bg-[radial-gradient(ellipse_80%_60%_at_50%_-10%,rgba(99,102,241,0.2),transparent)]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_40%_at_80%_80%,rgba(139,92,246,0.08),transparent)] dark:bg-[radial-gradient(ellipse_60%_40%_at_80%_80%,rgba(139,92,246,0.12),transparent)]" />
      </div>

      <div className="mx-auto max-w-3xl px-4 sm:px-6 text-center">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-indigo-50 dark:bg-indigo-950 px-3 py-1 text-xs font-medium text-indigo-700 dark:text-indigo-300 ring-1 ring-indigo-200 dark:ring-indigo-800 mb-8">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-indigo-500" />
          </span>
          {t.hero.badge}
        </span>

        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-gray-900 dark:text-white text-balance leading-tight">
          {t.hero.headline1}{" "}
          <span className="bg-gradient-to-r from-indigo-600 to-violet-600 dark:from-indigo-400 dark:to-violet-400 bg-clip-text text-transparent">
            {t.hero.headline2}
          </span>
        </h1>

        <p className="mt-6 text-lg sm:text-xl text-gray-500 dark:text-gray-400 text-pretty max-w-2xl mx-auto">
          {t.hero.subheadline}
        </p>

        <div id="waitlist" className="mt-10 scroll-mt-24">
          {submitted ? (
            <div className="inline-flex flex-col items-center gap-1 rounded-2xl bg-green-50 dark:bg-green-950 px-8 py-5 ring-1 ring-green-200 dark:ring-green-800">
              <span className="font-semibold text-green-700 dark:text-green-300">{t.hero.successTitle}</span>
              <span className="text-sm text-green-600 dark:text-green-400">{t.hero.successBody}</span>
            </div>
          ) : (
            <div className="flex flex-col items-center gap-3">
              <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 w-full max-w-md mx-auto">
                <div className="relative flex-1">
                  <label
                    htmlFor="waitlist-email"
                    className={`absolute left-4 transition-all duration-200 pointer-events-none text-gray-400 ${
                      focused || email ? "top-1 text-xs text-indigo-500 dark:text-indigo-400" : "top-3.5 text-sm"
                    }`}
                  >
                    {t.hero.emailPlaceholder}
                  </label>
                  <input
                    id="waitlist-email"
                    type="email"
                    required
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                    className="w-full rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 px-4 pt-5 pb-2 text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-600 dark:focus:ring-indigo-400"
                  />
                </div>
                <button
                  type="submit"
                  className="inline-flex items-center justify-center gap-2 rounded-lg bg-indigo-600 px-5 py-3 text-sm font-semibold text-white hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-600 active:scale-95 transition-all whitespace-nowrap"
                >
                  {t.hero.cta} <ArrowRight className="h-4 w-4" />
                </button>
              </form>
              <p className="flex items-center gap-1.5 text-xs text-gray-400 dark:text-gray-500">
                <Clock className="h-3 w-3" />
                {t.hero.hint}
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
